export default {
    hasTaxDependentOutside: 'TAX_RMB_SUMARY_STATIC6',
    name: 'TAX_RMB_SUMARY_STATIC5',
    birthDate: 'DOB',
    relation: 'TAX_RMB_SUMARY_STATIC4'
}